import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { openSidebar } from 'modules/imageCapture/actions';
import useStyles from './App-styles';
import { App } from './App';

export default withStyles(useStyles)(connect(null, {
  openSidebar,
})(App));
